import React, { useEffect } from "react"
import { useReportFormInfo } from "Pages/ReportsAlerts/Reports/@hooks"
import { reportFormData, useOfficePickup } from "Pages/ReportsAlerts/Reports/@signals"
import { array, object } from "yup"
import { AppOfficeGroupsAutocomplete } from "@components"
import { isEmpty } from "@ui-seeker/utils"

export default function OfficeGroupField() {

	useEffect(() => {
		return () => {
			if (!isEmpty(reportFormData.value)) setIdOfficeGroupInfo([])
		}
	}, [useOfficePickup.value])

	const {
		idOfficeGroup,
		setIdOfficeGroupInfo,
		error
	} = useReportFormInfo(reportFormData.peek().idOfficeGroup, "idOfficeGroup", object({ idOfficeGroup: array().required("Must provide an office group").min(1, "Must provide an office group") }))

	return <AppOfficeGroupsAutocomplete
		label="Group Office"
		placeholder="Select a Group Office"
		value={idOfficeGroup || []}
		error={error}
		onChange={e => setIdOfficeGroupInfo(e.target.value)}
	/>
}